import { useState } from "react";
import { Field, Honeypot, SubmitButton, SuccessBlock, useSubmit, inputCls, selectCls, validEmail } from "./fields";
import { toast } from "sonner";

const INIT = { name: "", phone: "", email: "", audience: "", subject: "", message: "", website: "" };

export default function ContactForm() {
  const [f, setF] = useState(INIT);
  const [deptEmail, setDeptEmail] = useState("info@maqlinesolutions.com");
  const { submit, loading, success, setSuccess } = useSubmit("/contact", "Thank you. Your enquiry has been received. Our team will contact you shortly.");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validEmail(f.email)) return toast.error("Please enter a valid email address.");
    if (f.audience === "Student / Job Seeker" || f.audience === "College / TPO / Faculty") {
      setDeptEmail("career@maqlinesolutions.com");
    } else {
      setDeptEmail("info@maqlinesolutions.com");
    }
    const ok = await submit(f);
    if (ok) setF(INIT);
  };

  if (success)
    return <SuccessBlock testId="contact-form-success" message="Thank you. Your enquiry has been received. Our team will contact you shortly." contactEmail={deptEmail} onReset={() => setSuccess(false)} />;

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="contact-form">
      <Honeypot value={f.website} onChange={set("website")} />
      <Field label="Name" required><input data-testid="ct-name" className={inputCls + " w-full"} value={f.name} onChange={set("name")} required /></Field>
      <Field label="Phone"><input className={inputCls + " w-full"} value={f.phone} onChange={set("phone")} placeholder="+91" /></Field>
      <Field label="Email" required><input data-testid="ct-email" type="email" className={inputCls + " w-full"} value={f.email} onChange={set("email")} required /></Field>
      <Field label="I am a">
        <select className={selectCls} value={f.audience} onChange={set("audience")}>
          <option value="">Select</option>
          <option>Business / Employer</option>
          <option>Student / Job Seeker</option>
          <option>College / TPO / Faculty</option>
          <option>Other</option>
        </select>
      </Field>
      <Field label="Subject" className="sm:col-span-2"><input className={inputCls + " w-full"} value={f.subject} onChange={set("subject")} /></Field>
      <Field label="Message" required className="sm:col-span-2"><textarea data-testid="ct-message" className={inputCls + " w-full h-28 py-2.5"} value={f.message} onChange={set("message")} required /></Field>
      <div className="sm:col-span-2">
        <SubmitButton loading={loading} testId="contact-form-submit">Send Message</SubmitButton>
      </div>
    </form>
  );
}
